import { API_BASE_URL, getTenantSubdomain } from "../config";

/**
 * @param {{ maincat: string|null, category: string|null, search: string|null, page: number }} args
 */
export const fetchProductsApi = async ({
  maincat = null,
  category = null,
  search = null,
  page = 1,
}) => {
  const company = getTenantSubdomain();
  let url = `${API_BASE_URL}/retail/products`;
  url += `?page=${page}`;
  if (maincat) {
    url += `&maincat=${maincat}`;
  }
  if (category) {
    url += `&category=${category}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "x-tenant-target": company,
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc4MjEzNDEwMSwianRpIjoiOWQwZDk2ZDQtYzAyNC00MTM0LWFhOTUtNGE1M2VjM2VkOThjIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6Im1pbGVzbGVtaSIsIm5iZiI6MTc4MjEzNDEwMSwiY3NyZiI6IjE2ZmZiMTQ3LTAxYzYtNGVjOC04Yzg4LTViMDAzNWY5N2UzMiIsImV4cCI6MTc4MjEzNzcwMX0.X-0244uc7wFYh0ZXYTwdwdLVA7Yemb_jkj0FQmUvtTQ",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch Products.");
  }
  let items = await response.json();
  //   console.log(items);
  return {
    items,
    nextPage: (items ?? []).length === 50 ? page + 1 : undefined,
  };
};
